import { useState, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { LiaUserSlashSolid } from "react-icons/lia";
import { MdOutlineDeliveryDining as Moto } from "react-icons/md";
import {
  Menu,
  Home,
  Layers,
  PackageSearch,
  Shapes,
  MapPin,
  Settings,
  ShieldCheck,
  Headset,
  Users,
  Package,
  ChevronDown,
  ChevronUp,
  Warehouse,
  Contact,
  CreditCard,
  MessageCircleWarning,
  Megaphone,
  Users2,
  FilePlus2,
  HelpCircle,
  Truck,
  Undo2,
  XCircle,
  Ban,
  PackageCheck,
  ScanLine,
  ClipboardList,
  CircleCheckBig,
  Link as Integration,
  MonitorCog,
  UserRoundCog,
  LayoutGrid,
} from "lucide-react";

export default function Navbar() {
  const { user, role, roles } = useAuth();
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const location = useLocation();
  const pathname = location.pathname;

  useLayoutEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setOpen(!mobile);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleLinkClick = () => {
    if (window.innerWidth < 1024) {
      setOpen(false);
    }
  };

  const navigation = [
    { name: "Tableau de bord", link: "/dashboard", icon: Home, badge: null, role: [0, 1, 2, 3, 4] },
    {
      name: "Commandes",
      icon: Package,
      subItems: [
        { name: "Tout les commands", link: "/orders/tout", icon: ClipboardList, badge: null },
        { name: "Nouvelle", link: "/orders/nouveau", icon: FilePlus2, badge: null },
        { name: "Livré", link: "/orders/livre", icon: PackageCheck, badge: null },
        { name: "Confirmé", link: "/orders/confirme", icon: CircleCheckBig, badge: null },
        { name: "Attente de confirmation", link: "/orders/reporte", icon: HelpCircle, badge: null },
        { name: "En suivi", link: "/orders/suivi", icon: Headset, badge: null },
        { name: "En livraison", link: "/orders/indelivery", icon: Truck, badge: null },
        { name: "Returné", link: "/orders/retour", icon: Undo2, badge: null },
        { name: "Refusé", link: "/orders/refuse", icon: XCircle, badge: null },
        { name: "Annulé", link: "/orders/annule", icon: Ban, badge: null },
      ],
      role: roles?.view_orders === 1 ? [0, 1, 2, 3] : [0, 1, 3],
    },
    { 
      name: "Produits", link: "/products", icon: PackageSearch, badge: null, role: [0] },
    { name: "Catégories", link: "/categories", icon: Layers, badge: null, role: [0] },
    {
      name: "Gestion de Stock",
      icon: Warehouse,
      subItems: [
        { name: "Produits", link: "/products", icon: PackageSearch, badge: null, role: roles?.view_products === 1 ? [1, 2] : [1] },
        { name: "Variantes", link: "/variants", icon: Shapes, badge: null, role: roles?.view_products === 1 ? [1, 2] : [1] },
        { name: "Catégories", link: "/categories", icon: Layers, badge: null, role: roles?.view_products === 1 ? [1, 2] : [1] },
      ],
      role: roles?.view_products === 1 || roles?.view_variants === 1 || roles?.view_categories === 1 ? [1, 2] : [1],
    },
    { name: "Villes", link: "/cities", icon: MapPin, badge: null, role: [0, 1, 2, 3] },
    { name: "Configurations", link: "/configs", icon: Settings, badge: null, role: roles?.edit_config === 1 ? [1, 2] : [1] },
    { name: "Scan Retour", link: "/scan", icon: ScanLine, badge: null, role: roles?.scan_order === 1 ? [1, 2] : [1] },
    {
      name: "Équipe",
      icon: Users2,
      subItems: [
        { name: "Admins", link: "/admins", icon: ShieldCheck, badge: null, role: [1] },
        { name: "Vendeurs", link: "/sallers", icon: Users, badge: null, role: roles?.view_saller === 1 ? [1, 2] : [1] },
        { name: "Confirmateurs", link: "/confirmators", icon: Headset, badge: null, role: roles?.view_confirmator === 1 ? [1, 2] : [1] },
        { name: "Livreur", link: "/livreurs", icon: Moto, badge: null, role: roles?.view_confirmator === 1 ? [1, 2] : [1] },
        { name: "Fournisseurs", link: "/fournisseurs", icon: Contact, badge: null, role: roles?.view_fournisseurs === 1 ? [1, 2] : [1] },
        { name: "Roles", link: "/roles", icon: UserRoundCog, badge: null, role: [1] },
        { name: "Black list", link: "/black-list", icon: LiaUserSlashSolid, badge: null, role:roles?.view_blacklist === 1 ? [1, 2] : [1] },
      ],
      role: roles?.view_saller === 1 || roles?.view_confirmator === 1 || roles?.view_fournisseurs === 1 || roles?.view_blacklist === 1 ? [1, 2] : [1],
    },
    { name: "Les Paiementss", link: "/payments", icon: CreditCard, badge: null, role: [0, 3] },
    {
      name: "Les Paiements",
      icon: CreditCard,
      subItems: [
        { name: "Sallers", link: "/payments/sallers", icon: Users, badge: null, role: roles?.view_saller_invoices === 1 ? [1, 2] : [1] },
        { name: "confirmators", link: "/payments/confirmators", icon: Headset, badge: null, role: roles?.view_confirmator_invoices === 1 ? [1, 2] : [1] },
        // { name: "Livreurs", link: "/payments/livreurs", icon: Moto, badge: null, role: roles?.view_confirmator_invoices === 1 ? [1, 2] : [1] },
        { name: "System", link: "/payments/system", icon: MonitorCog, badge: null, role: 1 },
      ],
      role: roles?.view_saller_invoices === 1 || roles?.view_confirmator_invoices === 1 ? [1, 2] : [1]
    },
    {
      name: "Intégrations",
      icon: Integration,
      subItems: [
        { name: "Livraison", link: "/integration/delivery", icon: Truck, badge: null, role: [1] },
        { name: "Applications", link: "/integration/applications", icon: LayoutGrid, badge: null, role: user.id === 23 || user.id === 169 || user.id === 122 || user.id === 126 ? [0] : [9] },
      ],
      role: [0, 1],
    },
    { name: "Réclamations", link: "/reclamations", icon: MessageCircleWarning, badge: null, role: roles?.view_reclamations === 1 ? [0, 1, 2, 3] : [0, 1, 3] },
    { name: "Annonces", link: "/annonces", icon: Megaphone, badge: null, role: roles?.view_annonces === 1 ? [1, 2] : [1] },
  ];

  const isActive = (link) => pathname === link;

  const toggleSection = (sectionName) => {
    setActiveSection(activeSection === sectionName ? null : sectionName);
  };

  const hasAccess = (item) => {
    if (item.permissionCheck) {
      return item.permissionCheck();
    }

    const itemRole = item.role;
    if (!itemRole) return true;
    if (Array.isArray(itemRole)) {
      return itemRole.includes(role);
    }
    return role === itemRole;
  };

  const renderNavItem = (item) => {
    if (!hasAccess(item)) return null;

    if (item.subItems) {
      const isOpen = activeSection === item.name;

      return (
        <div key={item.name} className="space-y-1">
          <button
            onClick={() => toggleSection(item.name)}
            className={`group cursor-pointer flex items-center justify-between w-full px-3 py-2.5 text-[10px] 
                        hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-500)] hover:shadow-sm font-medium text-gray-600 
                        rounded-xl transition-all duration-500`}
          >
            <div className="flex items-center whitespace-nowrap">
              <item.icon
                className={`mr-3 h-5 w-5 ${
                  isOpen ? "text-[var(--color-primary-500)] " : "text-gray-400 group-hover:text-[var(--color-primary-500)]"
                }`}
              />
              {open && <span>{item.name}</span>}
            </div>
            {open && (isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />)}
          </button>

          {isOpen && open && (
            <div className="ml-8 space-y-0.5">
              {item.subItems
                .filter((subItem) => hasAccess(subItem))
                .map((subItem) => (
                  <Link
                    key={subItem.name}
                    to={subItem.link}
                    onClick={handleLinkClick}
                    className={`group flex items-center justify-between px-3 py-2 text-[10px] font-medium rounded-xl border 
                               transition-all duration-200 hover:shadow-sm
                               ${
                                 isActive(subItem.link)
                                   ? "bg-[var(--color-primary-50)] border-[var(--color-primary-500)] text-[var(--color-primary-500)]"
                                   : "border-transparent text-gray-600 hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-500)]"
                               }`}
                  >
                    <div className="flex items-center whitespace-nowrap">
                      <subItem.icon
                        className={`mr-3 h-4 w-4 ${
                          isActive(subItem.link)
                            ? "text-[var(--color-primary-500)]"
                            : "text-gray-400 group-hover:text-[var(--color-primary-500)]"
                        }`}
                      />
                      <span>{subItem.name}</span>
                    </div>
                    {subItem.badge && (
                      <span className="bg-[#d1f0ec] text-[var(--color-primary-500)] text-[10px] px-2 py-1 rounded-full">
                        {subItem.badge}
                      </span>
                    )}
                  </Link>
                ))}
            </div>
          )}
        </div>
      );
    }

    return (
      <Link
        key={item.name}
        to={item.link}
        onClick={handleLinkClick}
        className={`group flex items-center justify-between px-3 py-2.5 text-[10px] font-medium rounded-xl border 
                   transition-all duration-200 hover:shadow-sm
                   ${
                     isActive(item.link)
                       ? "bg-[var(--color-primary-50)] border-[var(--color-primary-500)] text-[var(--color-primary-500)]"
                       : "border-transparent text-gray-600 hover:bg-[var(--color-primary-50)] hover:text-[var(--color-primary-500)]"
                   }`}
      >
        <div className="flex items-center whitespace-nowrap">
          <item.icon
            className={`mr-3 h-5 w-5 ${
              isActive(item.link) ? "text-[var(--color-primary-500)]" : "text-gray-400 group-hover:text-[var(--color-primary-500)]"
            }`}
          />
          {open && <span>{item.name}</span>}
        </div>
        {open && item.badge && (
          <span className="bg-[#d1f0ec] text-[var(--color-primary-500)] text-[10px] px-2 py-1 rounded-full">
            {item.badge}
          </span>
        )}
      </Link>
    );
  };

  return (
    <>
      <nav
        className={`
          ${open ? "w-[18%]" : "max-lg:w-0 w-20"}
          max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:h-screen max-lg:z-40
          max-lg:bg-white max-lg:shadow-xl
          ${open ? "max-lg:w-64" : "max-lg:w-0 max-lg:overflow-hidden"}
          transition-all duration-300 ease-in-out
          sticky top-[9vh] bottom-0 left-0 h-[91vh]
          border-r bg-white border-gray-200 shadow-xl md:shadow-none`}
      >
        <button
          className="max-lg:hidden absolute top-2.5 left-5 z-50 p-2 rounded-md bg-white cursor-pointer hover:bg-gray-100"
          onClick={() => setOpen(!open)}
        >
          <Menu className="h-6 w-6 text-gray-700" />
        </button>

        <div className="max-lg:hidden lg:flex flex-col h-[82vh] mt-16 pb-4 overflow-y-auto custom-scrollbar">
          <div className="flex-1 px-4 space-y-0.5">{navigation.map((item) => renderNavItem(item))}</div>
        </div>

        <div className="lg:hidden flex flex-col h-full overflow-y-auto pt-16">
          <div className="flex-1 px-4 pt-5 space-y-1.5">{navigation.map((item) => renderNavItem(item))}</div>
        </div>
      </nav>

      <button
        className="lg:hidden fixed bottom-6 left-6 z-50 p-3 rounded-full bg-[var(--color-primary-500)] text-white shadow-lg"
        onClick={() => setOpen(!open)}
      >
        <Menu className="h-6 w-6" />
      </button>
    </>
  );
}
